import SiteActions from "components/CSRAdmin/SiteActions";
import SendAnAlert from "components/CSRAdmin/SendAnAlert";
import Alerts from "components/CSRAdmin/Alerts";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { isAgentPortal } from "js/utilities";
import { useTranslation } from "react-i18next";

export default function CSRAdmin() {
  const { t } = useTranslation();
  useBreadcrumb([
    isAgentPortal()
      ? {
          name: t("AgentCSR-Admin-title-1"),
          url: "/dashboard",
        }
      : {
          name: t("AgentCSR-Admin-title-2"),
          url: "/policies",
        },
    {
      name: t("AgentCSR-Admin-title-3"),
      url: "#",
    },
  ]);

  return (
    <>
      <div className="container">
        <h1 className="text-center">{t("AgentCSR-Admin-title-4")}</h1>
      </div>
      <SiteActions />
      <SendAnAlert />
      <Alerts />
    </>
  );
}
